import { render } from "./ArrowUpIcon.vue?vue&type=template&id=4ccf160f&ts=true"
import script from "./ArrowUpIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowUpIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__